import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router"

export const Route = createFileRoute("/_authenticated/$slug/settings/workspace")({
  staticData: { title: "Workspace" },
  component: lazyRouteComponent(
    () => import("#pages/authenticated/settings/workspace.tsx"),
    "WorkspaceSettings",
  ),
})
